import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';

import AppStoreLink from 'components/shared/AppStoreLink';
import Modal from 'components/shared/Modal';

import img1x from 'consumer/account/upcoming-menus/mobile-promo/device.png';
import img2x from 'consumer/account/upcoming-menus/mobile-promo/device@2x.png';

import HeapAnalytics from 'services/HeapAnalytics';

function MobileAppPromoModal(): ReactElement {
  useEffect(() => {
    HeapAnalytics.track('IOS_promo_viewed');
  }, []);

  const [show, setShow] = useState(true);

  const onClose = () => {
    HeapAnalytics.track('IOS_promo_dismissed');
    setShow(false);
  };

  const onAppLinkClick = () => {
    HeapAnalytics.track('IOS_promo_clicked');
    setShow(false);
  };

  return (
    <Modal
      show={show}
      onClose={onClose}
      wrapperClassName="c-modal-mobile-app-promo"
      body={(
        <>
          <Modal.CloseBtn onClick={onClose} />
          <div className="row align-items-end">
            <div className="col-5 u-text--center">
              <img
                src={img1x}
                srcSet={`${img1x} 1x, ${img2x} 2x`}
                alt=""
              />
            </div>
            <div className="col-7 u-text--left pt-5 pb-4 pl-2">
              <h6 className="c-heading c-heading--brand-6 mb-2">
                Get the New App!
              </h6>
              <p className="u-text--sm">
                Manage your upcoming
                <br />
                deliveries, customize your
                <br />
                meals and get reminders!
              </p>
              <AppStoreLink onClick={onAppLinkClick} />
            </div>
          </div>
        </>
      )}
    />
  );
}

export default MobileAppPromoModal;
